export interface IConsistencyCheckVisibility {
    showDetails: boolean;
    isExpanded: boolean;
}
